import { FilterRow } from "@components/FilterTag/FilterTag";
import { Checkbox, LoadingSkeleton } from "@narmi/design_system";
import { $adminApi } from "../../../api";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { ThreadQuery } from "../types";

export function TeamTag({
  filters,
  expandedTag,
  setExpandedTag,
  setFilters,
}: {
  filters: ThreadQuery;
  expandedTag: string | null;
  setExpandedTag: Dispatch<SetStateAction<string | null>>;
  setFilters: Dispatch<SetStateAction<ThreadQuery>>;
}) {
  const { data: teamsData, isLoading } = $adminApi.useQuery("get", "/v2/admin/teams/", {
    params: {
      query: {
        ordering: ["name"],
      },
    },
  });

  const [teamFilters, setTeamFilters] = useState<string[]>(filters.assignee);

  useEffect(() => {
    setTeamFilters(filters.assignee);
  }, [expandedTag, filters.assignee]);

  return (
    <FilterRow.Tag
      label="Team"
      countApplied={filters.assignee.length}
      isExpanded={expandedTag === "team"}
      onPopoverDismiss={() => setExpandedTag(null)}
      onToggle={() => setExpandedTag(expandedTag === "team" ? null : "team")}
    >
      <FilterRow.FormContainer>
        <LoadingSkeleton isLoading={!teamsData || isLoading}>
          <Checkbox
            label="No assigned team"
            checked={teamFilters.includes("unassigned")}
            onChange={() => {
              const isChecked = teamFilters.includes("unassigned");
              const newFilters = isChecked
                ? teamFilters.filter((filter) => filter !== "unassigned")
                : [...teamFilters, "unassigned"];

              setTeamFilters(newFilters);
            }}
          />
          {teamsData &&
            teamsData.results.map((team) => (
              <Checkbox
                key={team.uuid}
                label={team.name}
                checked={teamFilters.includes(team.uuid!)}
                onChange={() => {
                  const isChecked = teamFilters.includes(team.uuid!);
                  const newFilters = isChecked
                    ? teamFilters.filter((filter) => filter !== team.uuid!)
                    : [...teamFilters, team.uuid!];

                  setTeamFilters(newFilters);
                }}
              />
            ))}
          {teamsData && !teamsData.results.length ? <FilterRow.NoResultsFound /> : null}
        </LoadingSkeleton>
      </FilterRow.FormContainer>
      <FilterRow.ActionBar
        onClear={() => {
          setExpandedTag(null);
          setTeamFilters([]);
          setFilters((prev) => ({
            ...prev,
            assignee: [],
            offset: 0,
          }));
        }}
        onApply={() => {
          setExpandedTag(null);
          setFilters((prev) => ({
            ...prev,
            assignee: teamFilters,
            offset: 0,
          }));
        }}
      />
    </FilterRow.Tag>
  );
}
